module.exports = __webpack_public_path__ + "static/media/pf.1398e1c8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pf.svg
// module id = 1133
// module chunks = 0